const REGULARIZATION_PRODUCTS = {};

const MONTHLY_DECLARATION: Record<string, any> = {
	A: {
		decl_full_1: {
			30: 499,
			90: 1272,
			180: 2395,
			365: 4491,
		},
	},
	B: {
		decl_full_1: {
			30: 599,
			90: 1527,
			180: 2495,
			365: 5389,
		},
	},
	C: {
		decl_full_1: {
			30: 399,
			90: 1018,
			180: 2295,
			365: 3593,
		},
	},
};

export const ENABLE_PREBILLING_FOR_YEAR = 2024;


export const PRODUCTS = {
	REGULARIZATION_PRODUCTS,
	MONTHLY_DECLARATION,
};
